import styled from "styled-components";

const UgcContainer = styled.div`
  display: flex;
  padding: 100px 0px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  background-color: ${(props) => props.theme.colors.primary.black};

  .ugc-label {
    color: ${(props) => props.theme.colors.primary.contrast};
    text-align: center;
    font-family: Mulish;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: 6px;
    text-transform: uppercase;
    margin: 0;
  }

  .ugc-title {
    color: ${(props) => props.theme.colors.primary.contrast};
    text-align: center;
    font-family: Mulish;
    font-size: 100px;
    font-style: normal;
    font-weight: 600;
    line-height: 125%;
    margin: 0;
  }

  .ugc-description {
    color: ${(props) => props.theme.colors.primary.contrast};
    font-family: Mulish;
    font-size: 25px;
    font-style: normal;
    font-weight: 600;
    line-height: 200%;
    padding: 0px 150px;
  }

  .ugc-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 50px;
    max-width: 1100px;
  }

  .how-it-works-wrapper {
    display: flex;
    align-items: flex-start;
    padding: 100px 80px 0 80px;
    width: 100%;
  }

  .how-it-works-image {
    width: 800px;
    height: 600px;
  }

  .how-it-works-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1 0 auto;
    background: ${(props) => props.theme.colors.primary.lightGray};
    padding: 100px;
    width: 800px;
    height: 600px;
  }

  .how-it-works-title {
    color: ${(props) => props.theme.colors.primary.black};
    font-family: Mulish;
    font-size: 25px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
    margin: 0;
  }

  .how-it-works {
    display: flex;
    padding: 100px 0px;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    align-self: stretch;
  }

  .how-it-works-description {
    color: ${(props) => props.theme.colors.primary.black};
    font-family: Mulish;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%;
    margin: 0;
  }

  .list-item {
    display: flex;
    align-items: flex-start;
    gap: 30px;
    align-self: stretch;
  }

  .list-column {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: stretch;
  }

  .arrow-container {
    display: flex;
    width: 40px;
    height: 40px;
    padding: 4px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    background: ${(props) => props.theme.colors.primary.main};
  }

  .arrow-icon {
    width: 13.867px;
    height: 13.867px;
    flex-shrink: 0;
  }

  .line {
    width: 2px;
    flex: 1 0 0;
    background: ${(props) => props.theme.colors.primary.black};
    height: 88px;
  }

  .list {
    display: flex;
    align-items: flex-start;
    gap: 30px;
    align-self: stretch;
  }
  .how-it-works-box {
    display: flex;
    padding-bottom: 30px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12.97px;
    flex: 1 0 0;
  }

  @media screen and (max-width: 1600px) {
    .how-it-works-wrapper {
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }

  @media screen and (max-width: 1024px) {
    display: flex;
    padding: 0px;
    flex-direction: column;
    align-items: center;

    .how-it-works-image {
      width: 100%;
      height: 100%;
    }
    .how-it-works-container {
      width: 100%;
      height: 100%;
      display: flex;
      padding: 50px 30px;
      flex-direction: column;
      align-items: center;
      align-self: stretch;
    }
    .how-it-works-wrapper {
      padding: 0;
    }
    .arrow-container {
      border-radius: 20px;
    }
    .ugc-wrapper {
      display: flex;
      padding: 50px 30px;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      align-self: stretch;
    }
    .ugc-label {
      color: ${(props) => props.theme.colors.primary.contrast};
      text-align: center;
      font-family: Mulish;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 100%;
      letter-spacing: 4.8px;
      text-transform: uppercase;
      margin: 0;
    }
    .ugc-title {
      color: ${(props) => props.theme.colors.primary.contrast};
      text-align: center;
      font-family: Mulish;
      font-size: 35px;
      font-style: normal;
      font-weight: 600;
      line-height: 125%;
      margin: 0;
    }
    .ugc-description {
      color: ${(props) => props.theme.colors.primary.contrast};
      font-family: Mulish;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 150%;
      letter-spacing: 0.32px;
      padding: 0;
      margin: 0;
    }
  }
`;

export default UgcContainer;
